export enum DescriptionListVariant {
  Columns = 'columns',
  Inline = 'inline',
  Stacked = 'stacked',
  SpaceBetween = 'space-between',
}

export type DescriptionListVariants = `${DescriptionListVariant}`;

/**
 * Description List provide/inject keys
 */
export interface DescriptionListInjection {
  /**
   * Divide the list groups with a border.
   */
  divide?: boolean;
  /**
   * Different variants of description lists.
   */
  variant?: DescriptionListVariants;
}
